<template>
  <div class="component-container">
    <div class="form-container">
      <div class="row">
        <div class="col-label">
          {{ $t('jtPasswordForm.LABEL_USERNAME') }}
        </div>
        <div class="col-content">
          <el-input v-model="userName" disabled="true"></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col-label">
          {{ $t('jtPasswordForm.LABEL_NEW_PASSWORD') }}
        </div>
        <div class="col-content">
          <el-input v-model="newPassword" type="password" show-password></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col-label">
          {{ $t('jtPasswordForm.LABEL_CONFIRM_NEW_PASSWORD') }}
        </div>
        <div class="col-content">
          <el-input v-model="confirmNewPassword" type="password" show-password></el-input>
        </div>
      </div>
      <div class="btn-container row">
        <el-button
          type="primary"
          @click="confirm"
          :disabled="confirmBtnDisabled"
        >
          <span class="yahei">{{ $t('jtPasswordForm.BTN_CONFIRM') }}</span>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import UserModel from '../../models/user'

export default {
  name: 'Changepassword',
  components: {},
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      teamname: '',
      token: '',
      userName: '',
    }
  },
  methods: {
    async confirm() {
      try {
        const passwordInfo = this._validate()
        const data = await UserModel.passwordReset(passwordInfo)
        if (data && data.errNo === 0) {
          let msg = this.$t('jtPasswordForm.TIPS_SUCCESS')
          let title = this.$t('jtPasswordForm.TIPS_TITLE_SUCCESS')
          let ok = this.$t('page.SUBMIT_CONFIRM_OK')
          let type = 'success'
          this.$msgbox({
            title: title,
            message: msg,
            showCancelButton: true,
            confirmButtonText: ok,
            showCancelButton: false,
            type: type,
          })
        }
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    _validate() {
      const newPassword = this.newPassword.trim()
      const confirmNewPassword = this.confirmNewPassword.trim()

      if (newPassword !== confirmNewPassword) {
        throw new Error(this.$t('jtRegisterForm.PASSWORD_CONFIRM_DIRTY'))
      }
      return { newPassword, token: this.token }
    },
  },

  computed: {
    confirmBtnDisabled() {
      return _.isEmpty(this.newPassword) || _.isEmpty(this.confirmNewPassword)
    },
  },

  created() {
    const router = this.$router
    const token = router.history.current.query.token
    const userName = router.history.current.query.userName
    this.token = token
    this.userName = userName
    if (token == null || userName == null) {
      this.$message.error(this.$t('jtPasswordForm.TOKEN_ID_IS_NULL'))
      return
    }
  },
}
</script>

<style lang="stylus" scoped>
.form-container {
  width: 100%;
  max-width: 600px;
  margin: 100px auto 0;
  padding: 10px;

  .row {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;

    .col-label {
      font-size: 16px;
      margin-right: 15px;
      margin-top: 10px;
      width: 150px;
    }

    .col-content {
      width: 100%;
    }

    button {
      min-width: 100px;
      font-size: 16px;
    }
  }
}
</style>
